import { render, staticRenderFns } from "./lkuKoranCampaign.vue?vue&type=template&id=5efdf346"
import script from "./lkuKoranCampaign.vue?vue&type=script&lang=js"
export * from "./lkuKoranCampaign.vue?vue&type=script&lang=js"
import style0 from "./lkuKoranCampaign.vue?vue&type=style&index=0&id=5efdf346&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports